import { Cust_hasSingleLocation } from '../Cust/Cust.serverPrefs'
import { Flow_sync } from '../Flow/Flow.sync'
import { Loca_ownershipSync } from '../Loca/Loca.ownership'
import { Proc_sync } from '../Proc/Proc.sync'
import { Team_sync } from '../Team/Team.sync'
import { User_profilesSync } from '../User/User.profiles'
import { WF_sync } from '../WF/WF.sync'
import { Unit_sync } from '../Unit/Unit.sync'
import { Noti_sync } from '../Noti/Noti.sync'
import { Rpts_statusSync } from '../Rpts/Rpts.sync.status'
import { Rpts_statusFlowSync } from '../Rpts/Rpts.sync.statusFlow'
import { Guides_sync } from '../Guid/Guid.sync'
import type { ClientLogger } from '../../../shared/lib/ClientLogger.no-deps'
import { Note_sync } from '../Note/Note.sync'

/**
 * Sync.syncCommon is for things that sync the same whether on login or periodic sync
 */
export async function Sync_syncCommon(logger: ClientLogger) {
    logger.log(`Sync_syncCommon start`)
    await Promise.all([
        !Cust_hasSingleLocation() && Loca_ownershipSync(),
        User_profilesSync(),
        WF_sync(logger),
        Proc_sync().then(() => Flow_sync()),
        Cust_hasSingleLocation() && Unit_sync(),
        Cust_hasSingleLocation() && Noti_sync(),
        Cust_hasSingleLocation() && Team_sync(),
        Rpts_statusSync(),
        Rpts_statusFlowSync(),
        Guides_sync(logger),
        Note_sync(logger),
    ])
    logger.log(`Sync_syncCommon done`)
}
